import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31ab74a0")

_pushScopeId("data-v-31ab74a0")
const _hoisted_1 = { class: "mypageselecttabs" }
const _hoisted_2 = { class: "mypageselecttabs-listarea" }
const _hoisted_3 = { class: "mypageselecttabs-listarea-button-textarea" }
const _hoisted_4 = { class: "mypageselecttabs-listarea-button-textarea" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "mypageselecttabs-blurarea" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectLeft(...args))),
        class: "mypageselecttabs-listarea-button"
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", {
            class: "mypageselecttabs-listarea-button-textarea-text",
            style: _ctx.styleTextColorSelectedLeft
          }, _toDisplayString(_ctx.leftTitle), 5)
        ]),
        _createVNode("div", {
          class: "mypageselecttabs-listarea-button-indicator",
          style: _ctx.styleOpacitySelectedLeft
        }, null, 4)
      ]),
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectRight(...args))),
        class: "mypageselecttabs-listarea-button"
      }, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", {
            class: "mypageselecttabs-listarea-button-textarea-text",
            style: _ctx.styleTextColorSelectedRight
          }, _toDisplayString(_ctx.rightTitle), 5)
        ]),
        _createVNode("div", {
          class: "mypageselecttabs-listarea-button-indicator",
          style: _ctx.styleOpacitySelectedRight
        }, null, 4)
      ])
    ]),
    _hoisted_5
  ]))
})